import { useOrders } from "../hooks/useOrders";
import { useAuthPrincipal } from "../hooks/useAuthPrincipal";
import { OrdersTable } from "../components/OrdersTable";
import { ErrorBanner, LoadingState } from "../components/States";

export function SellerOrdersPage() {
  const { principal } = useAuthPrincipal();
  const { data, isLoading, isError, error, refetch } = useOrders();

  const mySales = data?.items.filter((order) => order.sellerWalletId === principal?.walletId) ?? [];

  return (
    <div className="stack">
      <h1>My sales</h1>
      {isLoading && <LoadingState label="Loading your sales…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}
      {data && <OrdersTable orders={mySales} emptyLabel="No sales yet." />}
    </div>
  );
}
